// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3k82z","sendOtp":"AuthorizeToLogin_sendOtp__lypEh"};